import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { useMedia } from 'react-use';

import { useToken } from '@sunwebgroup/ui-components';

const BreakpointContext = React.createContext({
  isDesktopSm: false,
  isDesktopMd: false,
  isDesktopLg: false,
  isDesktopXl: false,
  isTablet: false,
  isMobile: false,
});
export const BreakpointProvider = ({ children }: PropsWithChildren) => {
  const mqDesktopSm = useToken<string>('mq_desktop_sm');
  const mqDesktopMd = useToken<string>('mq_desktop_md');
  const mqDesktopLg = useToken<string>('mq_desktop_lg');
  const mqDesktopXl = useToken<string>('mq_desktop_xl');
  const mqTablet = useToken<string>('mq_tablet');
  const mqMobile = useToken<string>('mq_mobile');

  const isMobile = useMedia(mqMobile, false);
  const isTablet = useMedia(mqTablet, false);
  const isDesktopSm = useMedia(mqDesktopSm, false);
  const isDesktopMd = useMedia(mqDesktopMd, false);
  const isDesktopLg = useMedia(mqDesktopLg, false);
  const isDesktopXl = useMedia(mqDesktopXl, false);

  return (
    <BreakpointContext.Provider
      value={{
        isMobile,
        isTablet,
        isDesktopSm,
        isDesktopMd,
        isDesktopLg,
        isDesktopXl,
      }}
    >
      {children}
    </BreakpointContext.Provider>
  );
};
export const useBreakpoints = () => React.useContext(BreakpointContext);
